import { useLocation } from "react-router-dom";
import { useLocationStore } from "./store/useLocationStore";
import * as React from "react";

export default function LocationTracker() {
  const location = useLocation();
  const { setLocate } = useLocationStore();

  React.useEffect(() => {
    setLocate(location);
  }, [location, setLocate]);

  return null;
}
